import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PricingPlans from './components/PricingPlans';
import ComparisonTable from './components/ComparisonTable';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const pricingJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Pricing — Free AI Image Generator | $0 Forever, No Hidden Fees',
    url: `${SITE_URL}/pricing`,
    description: 'Our AI image generator is 100% free forever. No hidden fees, no credit card, no usage limits. Unlimited text to image generation for everyone.',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Free AI Image Generator',
      url: SITE_URL,
    },
    mainEntity: {
      '@type': 'Offer',
      name: 'Free AI Image Generator Plan',
      price: '0',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
      description: 'Unlimited AI image generation, all styles, no watermarks, no login required — completely free forever.',
      itemOffered: {
        '@type': 'Service',
        name: 'AI Image Generation',
        serviceType: 'AI Art Generation',
      },
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: SITE_URL,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Pricing',
        item: `${SITE_URL}/pricing`,
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Free AI Image Generator',
    applicationCategory: 'DesignApplication',
    operatingSystem: 'Web',
    url: SITE_URL,
    offers: [
      {
        '@type': 'Offer',
        name: 'Free Plan',
        price: '0',
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock',
        description: 'Unlimited free AI image generation with no login required.',
      },
    ],
  },
];

export default function PricingPage() {
  useEffect(() => {
    document.title = 'Pricing — Free AI Image Generator | $0 Forever, No Hidden Fees';

    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Our AI image generator is 100% free forever. No hidden fees, no credit card required, no usage limits. Unlimited text to image generation for everyone.');

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) metaKeywords.setAttribute('content', 'free AI image generator pricing, AI art generator free plan, no subscription AI image, unlimited free AI art');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/pricing`);

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', `${SITE_URL}/pricing`);

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', 'Pricing — Free AI Image Generator | $0 Forever, No Hidden Fees');

    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', 'Our AI image generator is 100% free forever. No hidden fees, no credit card required, no usage limits.');

    let twitterUrl = document.querySelector('meta[name="twitter:url"]');
    if (twitterUrl) twitterUrl.setAttribute('content', `${SITE_URL}/pricing`);

    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', 'Pricing — Free AI Image Generator | $0 Forever, No Hidden Fees');

    let lastMod = document.getElementById('last-modified-meta');
    if (lastMod) lastMod.setAttribute('content', new Date().toISOString().split('T')[0]);

    const existing = document.querySelectorAll('script[data-schema="pricing"]');
    existing.forEach((s) => s.remove());

    pricingJsonLd.forEach((schema, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'pricing');
      script.setAttribute('data-index', String(i));
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-schema="pricing"]').forEach((s) => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1b1e]">
      <Navbar />
      <main className="pt-20">
        <PricingPlans />
        <ComparisonTable />
      </main>
      <Footer />
    </div>
  );
}
